class EnumValue {
  declare value: string;

  declare label: string;

  constructor(value: string, label: string) {
    this.value = value;
    this.label = label;
  }
}

export default EnumValue;
